<template>
  <BaseModal modalColor="border-success bg-primary" iconModal="fa fa-edit" subtitulo="Cadastrar novo material" col-md="col-md-6" offset="12">
    <template v-slot:modalContent>
      <form ref="cadastroForm" @submit.prevent="submitIncluirForm">
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <FloatLabel variant="on">
                <InputText id="descricao" v-model="dado.descricao" size="small" style="width: 100%"
                           :invalid="campoVazio.includes('descricao')" autofocus/>
                <label for="descricao"><strong>descricao: <span class="text-danger font-bold">*</span></strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <FloatLabel variant="on">
                <InputNumber id="estoque" v-model="dado.estoque" size="small" style="width: 100%"
                             fluid :inputStyle="{ textAlign: 'right' }" :invalid="campoVazio.includes('estoque')"/>
                <label for="estoque"><strong>Estoque: <span class="text-danger font-bold">*</span></strong></label>
              </FloatLabel>
            </div>
          </div>
        </div>
        <div class="ibox-footer">
          <div class="float-right">
            <button type="submit" class="btn btn-primary font-bold">Confirmar</button>
          </div>
          <button class="btn btn-danger font-bold" @click="$emit('fechar')">
            Cancelar
          </button>
        </div>
      </form>
    </template>
  </BaseModal>
</template>

<script>
import BaseModal from '@/components/base/BaseModal.vue';
import {apiRequest} from "../../../public/js/utils/funcoes";
import {apiUrl} from "@/router/apiBackRoutes";


export default {
  name: "CadastrarMateriais",
  components: {
    BaseModal,
  },
  data() {
    return {
      dado: {
        descricao: "",
        estoque: "",
      },
      campoVazio: [],
    }
  },
  emits: ["fechar", "atualizarLista"],
  methods: {
    async submitIncluirForm() {
      const resultado = await apiRequest("POST", apiUrl.materiais.createList, this.dado);
      if (resultado.success) {
        this.$emit("atualizarLista", resultado.data);
        this.$toastMessage("success", "Registro salvo com sucesso!");
        this.$emit('fechar');
      } else {
        this.campoVazio = Object.keys(resultado.error);
        if (resultado.error && typeof resultado.error === "object") {
          for (const campo in resultado.error) {
            resultado.error[campo].forEach(msg => {
              this.$toastMessage("error", campo, msg);
            });
          }
        } else {
          this.$toastMessage("warn", "Atenção", "Erro inesperado ao salvar!");
        }
      }
    },
  },
}
</script>
